/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Notes_TitleInputs */

const en_colleague_notes_title = /** @type {(inputs: Colleague_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const ja_colleague_notes_title = /** @type {(inputs: Colleague_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メモ`)
};

const fr_colleague_notes_title = /** @type {(inputs: Colleague_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const de_colleague_notes_title = /** @type {(inputs: Colleague_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Colleague_Notes_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_notes_title = /** @type {((inputs?: Colleague_Notes_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Notes_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_notes_title(inputs)
	if (locale === "ja") return ja_colleague_notes_title(inputs)
	if (locale === "fr") return fr_colleague_notes_title(inputs)
	return de_colleague_notes_title(inputs)
});